import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  taxCatObj: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
